export const AttachmentFormats = '.doc,.docx,.odt,.pdf,.jpg,.jpeg,.png,.txt,.rar,.zip,.html,.htm,.xls,.xlsx,.ods,.ppt,.pptx,.eps';

export const MaxFilesizeInBytes = 20000;
